// Account-login token stays only in this page's memory, never across a reload.
let accountToken:string|undefined;
let returning=false;
export function rememberUserCenter(token:string){accountToken=token;returning=false;}
export function prepareUserCenterReturn(){returning=!!accountToken;}
export function readUserCenterReturn(){return returning?accountToken:undefined;}
export function consumeUserCenterReturn(){returning=false;}
export function clearUserCenterSession(){accountToken=undefined;returning=false;}
export function getUserCenterToken(){return accountToken;}
